var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{class:_vm.ico,on:{"click":function($event){return _vm.Switch()}}}),_c('input',{class:_vm.active ? _vm.Style : 'login_input',attrs:{"type":_vm.type,"placeholder":_vm.textpl},on:{"input":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }